import produce from 'immer';
import {
  CHANGE_PARTNER,
  REMOVE_PARTNER,
  CHANGE_PARTNER_ADD_ACTION,
  CHANGE_PARTNER_FLAG,
  CHANGE_DIRECTOR,
  VERIFED_OTP,
  SET_PAN,
  AUTH_TOKEN,
  SEND_OTP_DATA,
  SAVE_DOCUMENT_LIST,
  CREDIT_AVAIL_RESPONSE,
  SAVE_BRO,
  SET_WINDOW,
  CLEAR_WINDOW,
  NEXT_ESIGN,
  GET_PAN,
  SET_TOAST,
  STOP_LOADER,
  START_LOADER,
  CREATE_BRO,
  KNOW_YOUR_CREDIT,
  SAVE_OFFER,
  SAVE_UPDATE_BRO,
  UPDATE_BRO,
  SAVE_ESIGN_INIT,
  ERROR_ESIGN_INIT,
  ESIGN_INIT,
  SEND_OTP,
  AUTH_TOKEN_BORROWER,
  SET_STEP,
  SET_REPEAT,
  SAVE_IFSC_API,
  SET_OFFER,
  AUTH_USER,
  SAVE_ESIGN_LIST,
  PENNY_DROP_DATA,
  PENNY_DROP_CALL,
  CREATE_BANK_ACC,
  SAVE_BANK_ACC,
  GET_BANK_LIST,
  SAVE_BANK_LIST,
  IFSC_API,
  INIT_EMANDATE,
  SAVE_INIT_EMANDATE,
  CHANGE_PARTNER_TEMP_FLAG,
  SET_API_KEY,
  SET_CUST_CODE,
  LOGOUT_USER,
  PHY_NACH,
  SAVE_PHY_NACH,
  SAVE_EMANDATE_LIST,
  SET_REPEAT_MOBILE,
  SAVE_EMAIL_ESIGN,
  SET_PIN,
  GET_PIN,
  ADD_LOAD_DOCUMENT,
  REMOVE_LOAD_DOCUMENT
 
} from './constants';

export const initialState = {
  onboardingStep: "COMPANY",
  partners: [],
  submitPartner: false,
  submitDirector:false,
  directors: {},
  verfiedOTP: false,
  borrowerResponse: null,
  panList:{},
  panListCurrent:null,
  pinList: {},
  currentOffer: null,
  otpResponse:null,
  authToken: null,
  documentList: null,
  windowOBJ: null,
  myToasst: false,
  loaderDirector: false,
  loaderOffer: true,
  OtpScreen: false,
  loaderOTP: false,
  loaderRegister: false,
  loaderEsign: false,
  loaderDocument: false,
  esignResponse: null,
  esignResponseError: null,
  repeatUser: false,
  actList: null,
  ifscCodeList: {},
  esignList: null,
  esignInterVal: null,
  pennyDrop: null,
  loaderIFSC: false,
  loaderPennyDrop: false,
  loaderBank: false,
  bankAccount: null,
  emandateData: null,
  loaderEmandate: false,
  loaderInitEmandate: false,
  removeParterBlock: false,
  apiKey: null,
  custCode: null,
  emandateNACH: null,
  loaderEsignDocument: false,
  esignResponseEmail: null,
  heeelllooo: "343243",
  repeatUserMobile: null,
  documentLoader: []
};

const getpartnerKey = (pp,pindex) => {
  let indexvalue = null;
  for(var x in pp) {
    if(pp[x].myid === pindex) {
      indexvalue = x;
    }
  }
  return indexvalue;
}

/* eslint-disable default-case, no-param-reassign */
const appReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case VERIFED_OTP: {
        draft.verfiedOTP = true;
        break;
      }
      case LOGOUT_USER: {
        draft.borrowerResponse = null;
        draft.OtpScreen = false;
        draft.onboardingStep = "COMPANY";
        draft.repeatUser = false;
        break;
      }
      case UPDATE_BRO: {
        draft.loaderDirector = true;
        break;
      }
      case SAVE_UPDATE_BRO: {
        draft.loaderDirector = false;
        draft.onboardingStep = "OFFER";
        draft.borrowerResponse = action.payload.data;
        break;
      }
      case SET_API_KEY: {
        draft.apiKey = action.payload.key;
        break;
      }
      case SET_CUST_CODE: {
        draft.custCode = action.payload.key;
        break;
      }
      case SAVE_ESIGN_INIT: {
        draft.esignResponse = action.payload.data;
        draft.esignResponseError = null;
        break;
      }
      case ERROR_ESIGN_INIT: {
        draft.esignResponse = null;
        draft.esignResponseError = action.payload.data;
        break;
      }
      case ESIGN_INIT: {
        draft.loaderEsign = true;
        draft.esignResponse = null;
        draft.esignResponseError = null;
        break;
      }
      case PHY_NACH: {
        draft.loaderEmandate = true;
        break;
      }
      case SAVE_PHY_NACH: {
        draft.loaderEmandate = false;
        draft.emandateNACH = action.payload.response;
        break;
      }
      case CREATE_BANK_ACC: {
        draft.loaderBank = true;
        break;
      }
      case SAVE_BANK_ACC: {
        draft.loaderBank = false;
        draft.onboardingStep = "ESIGN";
        break;
      }
      case GET_BANK_LIST: {
        draft.loaderBank = true;
        break;
      }
      case SAVE_BANK_LIST: {
        draft.loaderBank = false;
        draft.bankAccount = action.payload.response;
        break;
      }
      case ADD_LOAD_DOCUMENT: {
        draft.documentLoader.push(action.payload.documentId);
        break;
      } 
      case REMOVE_LOAD_DOCUMENT: {
        const index_find = draft.documentLoader.indexOf(action.payload.documentId);
        if (index_find > -1) {
          draft.documentLoader.splice(index_find, 1);
        }
        break;
      }       
      case INIT_EMANDATE: {
        draft.loaderEmandate = true;
        break;
      }
      case SAVE_INIT_EMANDATE: {
        draft.loaderEmandate = false;
        draft.emandateData = action.payload.response;
        break;
      }
      case SAVE_EMAIL_ESIGN: {
        draft.loaderEsignDocument = false;
        draft.esignResponseEmail = action.payload.response;
        break;
      }
      case CREATE_BRO: {
        draft.loaderRegister = true;
        break;
      }
      case CHANGE_PARTNER: {
        draft.submitPartner = false;
        draft.partners.push(action.payload.partners);
        break;
      }
      case REMOVE_PARTNER: {
        draft.submitPartner = false;
        draft.removeParterBlock = false;
        draft.partners = action.payload.partners;
        break;
      }
      case SET_OFFER: {
        draft.loaderOffer = true;
        break;
      }
      case GET_PAN: {
        draft.panLoading =  true;
        break;
      }
      case GET_PIN: {
        draft.pinLoading =  true;
        break;
      }
      case SAVE_ESIGN_LIST: {
        draft.esignList = action.payload.data;
        draft.esignInterVal =  action.payload.interVal;
        break;
      }
      case SEND_OTP: {
        draft.loaderOTP =  true;
        break;
      }
      case AUTH_USER: {
        draft.loaderOTP =  true;
        break;
      }
      case KNOW_YOUR_CREDIT: {
        draft.loaderOffer =  true;
        break;
      }
      case IFSC_API: {
        draft.loaderIFSC =  true;
        break;
      }
      case SAVE_IFSC_API: {
        var ifscc = action.payload.data && action.payload.data.IFSC;
        if(ifscc){
          draft.ifscCodeList[ifscc] = action.payload.data;
        }
        draft.loaderIFSC =  false;
        break;
      }
      case PENNY_DROP_DATA: {
        draft.pennyDrop = action.payload.response;
        draft.loaderPennyDrop = false;
        break;
      }
      case PENNY_DROP_CALL: {
        draft.loaderPennyDrop = true;
        break;
      }
      case SET_PAN: {
        draft.panList[action.payload.pan] = action.payload.response;
        draft.panListCurrent = action.payload.pan;
        draft.panLoading =  false;
        break;
      }
      case SET_PIN: {
        draft.pinList[action.payload.pin] = action.payload.response;
        draft.pinLoading =  false;
        break;
      }
      case SET_TOAST: {
        draft.myToasst = action.payload.toast;
        break;
      }
      case SET_REPEAT: {
        draft.repeatUser = true;
        draft.OtpScreen = true;
        break;
      }
      case SET_REPEAT: {
        draft.repeatUser = true;
        draft.OtpScreen = true;
        break;
      }
      case SET_REPEAT_MOBILE: {
        draft.repeatUser = true;
        draft.OtpScreen = true;
        draft.repeatUserMobile = action.payload.mobile_number;
        break;
      }      
      case AUTH_TOKEN: {
        draft.onboardingStep = "DIRECTOR";
        draft.authToken = action.payload.response;
        break;
      }      
      case AUTH_TOKEN_BORROWER: {
        draft.borrowerResponse = action.payload.borrower;
        draft.authToken = action.payload.response;
        draft.actList = action.payload.responseAct; 
        draft.loaderOTP =  false;       
        break;
      }
      case SAVE_EMANDATE_LIST: {
        draft.onboardingStep = "EMANDATE_PHY_UPLOAD";
        break;
      }
      case SEND_OTP_DATA: {
        draft.loaderOTP =  false;  
        draft.otpResponse = action.payload.response;
        break;
      }
      case SAVE_BRO: {
        draft.loaderRegister = false;
        draft.OtpScreen = true;
        draft.borrowerResponse = action.payload.data;
        break;
      }
      case START_LOADER: {
        draft[action.payload.loaderName] = true;
        break;
      }
      case STOP_LOADER: {
        draft[action.payload.loaderName] = false;
        break;
      }
      case CREDIT_AVAIL_RESPONSE: {
        draft.borrowerResponse = action.payload.response;
        draft.loaderOffer = false;
        break;
      }
      case SAVE_OFFER: {
        draft.onboardingStep = "DOCUMENT";
        draft.borrowerResponse.updated_offers = action.payload.response;
        break;
      }
      case NEXT_ESIGN: {
        draft.onboardingStep = "ESIGN";
        break;
      }
      case SET_STEP: {
        draft.onboardingStep = action.payload.step;
        break;
      }
      case SAVE_DOCUMENT_LIST: {
        draft.loaderDocument = false;
        draft.documentList = action.payload.response;
        break;
      }
      case SET_WINDOW: {
        draft.windowOBJ = action.payload.window;
        break;
      }
      case CLEAR_WINDOW: {
        draft.windowOBJ = null;
        break;
      }
      case CHANGE_PARTNER_FLAG: {

        var xyz = {...action.payload.partner,flag: true};
        var currentPartnerkey = getpartnerKey(state.partners,action.payload.index)
        
        if(currentPartnerkey) {
          for(var abc in xyz) {
            draft.partners[currentPartnerkey][abc] = xyz[abc];
          }
        }

        let cnt = draft.partners.length;
        let cntP = 0;
        for(let x in draft.partners) {
          if(draft.partners[x].flag && draft.partners[x].flag === true) {
            cntP++;
          }
        }

        if(cntP === cnt) {
          draft.submitPartner = true;
        }
        break;
      }
      case CHANGE_PARTNER_TEMP_FLAG: {
        var xyz1 = action.payload.partner;
        var currentPartnerkey1 = getpartnerKey(state.partners,action.payload.index)
        if(currentPartnerkey1) {
          draft.partners[currentPartnerkey1]["unusedvalue"] = {};
          for(var abc1 in xyz1) {
            draft.partners[currentPartnerkey1]["unusedvalue"][abc1] = xyz1[abc1];
          }
        }   
        break;     
      }
      case CHANGE_PARTNER_ADD_ACTION: {
        var currentPartnerkey2 = getpartnerKey(state.partners,action.payload.key)
        if(currentPartnerkey2) {
          draft.partners[currentPartnerkey2].action = action.payload.action;  
        }        
        break;
      }
      case CHANGE_DIRECTOR: {
        draft.submitDirector = true;
        draft.directors = action.payload.directors;
        break;
      }
      default:
        return state;
    }
    return draft;
  });

export default appReducer;
